import Card from '@mui/material/Card';
import React from 'react';

const SalesLv1MetadataCard = (props) => {
  return (
    <Card variant='outlined' sx={{ width: '100%', height: '100%' }} >
      {props.children}
    </Card>
  );
}
export default SalesLv1MetadataCard;
